export default __webpack_public_path__ + "static/media/doc-avatar.a5cd8d91.svg";